module.exports = __webpack_public_path__ + "img/subBanner1.92507dc9.png";